import {USER_TYPES} from 'common/constants'

/** Admin/staff/teacher browse the school module under `/institute`. */
export const isInstituteUserType = (userType?: string | null) =>
  [USER_TYPES.ADMIN, USER_TYPES.STAFF, USER_TYPES.TEACHER].includes(userType ?? '')

/**
 * In-app link for a notification's `webUrl`.
 *
 * Students/parents browse legacy pages at un-prefixed front-module paths
 * (e.g. `/homework/view/:id`); only admin/staff/teacher routes live under
 * `/institute` — prefixing for everyone sends students to the school module,
 * which denies them (404 in the iframe).
 */
export const buildNotificationLink = (
  webUrl: string | null | undefined,
  isInstituteUser: boolean
): string => {
  if (!webUrl) return '#'
  const path = webUrl.startsWith('/') ? webUrl : `/${webUrl}`
  if (/^\/(school|institute)(\/|$)/.test(path)) return path
  return isInstituteUser ? `/institute${path}` : path
}

/** Where "View all" / the sidebar entry sends the user for the full inbox. */
export const getNotificationsInboxPath = (isInstituteUser: boolean) =>
  isInstituteUser ? '/institute/notifications/admin' : '/notifications'
